/**
 * lib/ga.js — Google Analytics 4 (chargement conditionnel au consentement RGPD)
 * Module MOOC.
 *
 * GA4 n'est chargé qu'après acceptation des cookies analytiques (une seule balise gtag).
 * Identifiant : REACT_APP_GA_MEASUREMENT_ID, à défaut celui de la plateforme (public).
 * Les pages vues sont envoyées à chaque changement de route par components/SuiviPages.js.
 */

export const CONSENT_KEY = 'innov360_cookie_consent';

export const GA_ID_DEFAUT = 'G-7CMVHGTXDS';
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || GA_ID_DEFAUT;

let initialized = false;
let dernierChemin = null;

export function initGA() {
  if (!GA_ID || initialized || typeof document === 'undefined') return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    // Pages vues envoyées à la main (application à une page : une par route)
    window.gtag('config', GA_ID, { send_page_view: false });

    if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);
    }

    initialized = true;
    // Page affichée au moment du consentement
    gaPageView(window.location.pathname);
  } catch { /* silencieux */ }
}

export function loadGAIfConsented() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return;
    const consent = JSON.parse(raw);
    if (consent?.analytics === true) initGA();
  } catch { /* silencieux */ }
}

export function gaEvent(eventName, params = {}) {
  if (!initialized || typeof window.gtag !== 'function') return;
  try { window.gtag('event', eventName, params); } catch { /* silencieux */ }
}

/** Page vue GA4 (sans la chaîne de requête : jamais de jeton envoyé à Google). */
export function gaPageView(path, title = document.title) {
  if (!initialized || typeof window.gtag !== 'function') return;
  if (path === dernierChemin) return;
  dernierChemin = path;
  try {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.origin + path,
      page_title: title,
    });
  } catch { /* silencieux */ }
}
